import { IntentFrame } from '../architecture/mosaic_pipeline';

export class W3CEgressAdapter {
  private wasPinching = false;
  private symbioteInjected = false;
  private readonly POINTER_ID = 10001;

  public dispatchToDOM(frame: IntentFrame): void {
    const iframe = document.getElementById('excalidraw-iframe') as HTMLIFrameElement;
    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

    const targetWin = iframe.contentWindow as any;
    const targetDoc = iframe.contentDocument;

    // 1. SYMBIOTE INJECTION (Lazy load into iframe)
    if (!this.symbioteInjected && targetWin.Element) {
      const origSet = targetWin.Element.prototype.setPointerCapture;
      targetWin.Element.prototype.setPointerCapture = function(id: number) {
        if (id >= 10000) return; 
        if (origSet) origSet.call(this, id);
      };
      const origRel = targetWin.Element.prototype.releasePointerCapture;
      targetWin.Element.prototype.releasePointerCapture = function(id: number) {
        if (id >= 10000) return;
        if (origRel) origRel.call(this, id);
      };
      this.symbioteInjected = true;
    }

    // 2. Coordinate Translation
    const rect = iframe.getBoundingClientRect();
    const internalX = (frame.smoothedX * window.innerWidth) - rect.left;
    const internalY = (frame.smoothedY * window.innerHeight) - rect.top;
    
    const target = targetDoc.elementFromPoint(internalX, internalY) || targetDoc.body;
    const PointerCtor = targetWin.PointerEvent || PointerEvent;
    const MouseCtor = targetWin.MouseEvent || MouseEvent;

    const baseInit = {
      bubbles: true, cancelable: true, composed: true,
      clientX: internalX, clientY: internalY,
      screenX: internalX + rect.left, screenY: internalY + rect.top,
    };

    const pointerInit: PointerEventInit = {
      ...baseInit, pointerId: this.POINTER_ID, pointerType: 'pen', isPrimary: true,
      button: frame.isPinching ? 0 : -1, buttons: frame.isPinching ? 1 : 0,
      pressure: frame.isPinching ? 0.8 : 0
    };

    if (frame.isPinching && !this.wasPinching) {
      target.dispatchEvent(new PointerCtor('pointerdown', pointerInit));
      target.dispatchEvent(new MouseCtor('mousedown', { ...baseInit, button: 0, buttons: 1 }));
    }
    
    target.dispatchEvent(new PointerCtor('pointermove', pointerInit));

    if (!frame.isPinching && this.wasPinching) {
      const upInit = { ...pointerInit, button: 0, buttons: 0, pressure: 0 };
      target.dispatchEvent(new PointerCtor('pointerup', upInit));
      target.dispatchEvent(new MouseCtor('mouseup', { ...baseInit, button: 0, buttons: 0 }));
      target.dispatchEvent(new MouseCtor('click', { ...baseInit, button: 0, buttons: 0 })); // REACT UI PERMEABILITY
    }

    this.wasPinching = frame.isPinching;
  }
}
